import { AccountsController } from './accounts-controller';
import { OptionsService } from '../services/options-service';
import { ObfClientSettings } from '../interfaces/obf-client-settings.interface';
import { Dependencies } from '../interfaces/dependencies-types';
import DependenciesInjector from '../helpers/dependencies-injector';

declare global {
    interface Window {
        _OBF: any
    }
}
export class EmbedController implements Dependencies {
    private appUrl: string;
    private accountsController: AccountsController;
    private optionsService: OptionsService;

    public async initialize() {
        this.optionsService = await DependenciesInjector.getRegistered('OptionsService') as OptionsService;
        const obfClientSettings: ObfClientSettings = this.optionsService.getObfClientSettings();
        this.accountsController = await DependenciesInjector.getRegistered('AccountsController') as AccountsController;

        this.appUrl = obfClientSettings.app_url + 'embed/' + 'index.php';
        const base = document.createElement('base')
        base.href = document.location.pathname;
        document.head.appendChild(base);

        if (this.accountsController) {
            this.accountsController.registerCustomLoginHandler((activeTab: 'login' | 'register' = 'login') => {
                return new Promise((resolve, reject) => {
                    if (window._OBF.loginPopup) {
                        window._OBF.loginPopup((response: any) => {
                            resolve(response)
                        }, activeTab);
                    } else {
                        reject('Dont have loginPopup function');
                    }
                });
            });

            this.accountsController.registerCustomLogoutHandler(() => {
                return new Promise((resolve, reject) => {
                    if (window._OBF.logout) {

                        window._OBF.logout((status: any) => {
                            if (status === 'error') {
                                reject('Fail to logout');
                            } else {
                                resolve('Success logout');
                            }
                        })
                    } else {
                        reject('Dont have logout function');
                    }
                });
            })
        }
    }

    public init(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.appendNgApplication();
            resolve(true);
        });
    }

    /**
     * Appending Angular2 Application in parent DOM. .
     */
    private async appendNgApplication() {
        const obfIndex: string = await new Promise((res, rej) => {
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = (e) => {
                if (xhttp.readyState == 4 && xhttp.status == 200) {
                    res(xhttp.responseText);
                }
            };
            xhttp.open("GET", this.appUrl, true);
            xhttp.send();
        })

        const extractedElements = this.HTMLExtractor(obfIndex);
        // append elements and script in head
        const ngBox = document.querySelector('[obfcontainer]');
        ngBox.innerHTML = '';

        for (let index = 0; index < extractedElements.headContent.length; index++) {
            const copyOfElement = this.createCopyOfHTMLElement(extractedElements.headContent[index]);

            document.head.appendChild(copyOfElement);
        }
        for (let index = 0; index < extractedElements.bodyContent.length; index++) {
            const copyOfElement = this.createCopyOfHTMLElement(extractedElements.bodyContent[index]);

            if (ngBox) {
                ngBox.appendChild(copyOfElement);
            }
        }

        for (let index = 0; index < extractedElements.obfScripts.length; index++) {
            const copyOfElement = this.createCopyOfHTMLElement(extractedElements.obfScripts[index]);

            if (ngBox) {
                ngBox.appendChild(copyOfElement);
            }
        }

        return;
    }

    // urls and elements extractor 
    private HTMLExtractor(HTMLString: string): { headContent: any, bodyContent: any, obfScripts: any } {
        HTMLString = HTMLString.split(/<\/*(?:\s*)html[^>]*>/g)[3];
        const querySelectorForOBFScripts = 'link[href*="style"],script[src*="main"],script[src*="style"],script[src*="vendor"],script[src*="polyfills"],script[src*="runtime"],script[src*="nomodule-polyfill"]'
        // split head and body before create the HTML element to extract the content we need 
        let fakePage: Element = document.createElement('html');
        fakePage.innerHTML = HTMLString;
        // Catch all elements and sources we need to load obf
        const headContent = fakePage.querySelectorAll('head ' + '[embed-src]');
        const bodyContent = fakePage.querySelectorAll('body ' + '[embed-src]');
        const obfScripts = fakePage.querySelectorAll(querySelectorForOBFScripts);
        return { headContent: headContent, bodyContent: bodyContent, obfScripts: obfScripts }
    }

    private createCopyOfHTMLElement(element: Element) {
        let copyElement = document.createElement(element.tagName);


        let elementSRC: string = (element as any).src;
        let elementHREF: string = (element as any).href;

        for (var att, i = 0, atts = element.attributes, n = atts.length; i < n; i++) {

            att = atts[i];

            if (elementSRC && att.nodeName == 'src' && elementSRC.includes(document.location.origin)) {

                const replaceUrl = elementSRC.replace(document.location.origin + document.location.pathname, this.appUrl)

                copyElement.setAttribute(att.nodeName, replaceUrl);

            } else if (elementHREF && att.nodeName == 'href' && elementHREF.includes(document.location.origin)) {

                const replaceHREF = elementHREF.replace(document.location.origin + document.location.pathname, this.appUrl)

                copyElement.setAttribute(att.nodeName, replaceHREF);

            } else {

                copyElement.setAttribute(att.nodeName, att.nodeValue);
            }
        }

        copyElement.innerHTML = element.innerHTML;

        return copyElement
    }
}
